/* global $, ShopgateProductDetailsCore */

/**
 * This ShopgateProductDetailsCore plugin provides the functionality to put and remove
 * products on and from the customers favourite list.
 * @param  {Object} _core Reference to the ShopgateProductDetailsCore
 * @return {Object} An object with informations about the capabilities of this plugin
 */
var liveStockPlugin = function(_core, _coreOptions) {

	var scope = null,
		pluginUrls = null,
        pluginVars = null,
        productContainerLiveStock = null,
        productContainerStockQuantity = null,
        liveStockPreloader = null,
        productContainerAvailableText = null,
		ajaxError = false,
		debugLazyLiveStock = false; // turn on for debugging - livestock will be pending for at least 5 seconds

  // constants
  // display stock
  const ITEM_STOCK_DISPLAY_OFF = 'off';
  const ITEM_STOCK_DISPLAY_DEFAULT = 'default';
  const ITEM_STOCK_DISPLAY_ALWAYS_APPROX = 'always_approx';
  const ITEM_STOCK_DISPLAY_ALWAYS_EXACT = 'always_exact';

	/**
	 * Called before the core is completely initialized
	 * @param  {String} callType The type of the function call (products.ui or products.data)
	 * @param  {Object} data Useful data {products, coreOptions}
	 */
	function _onCoreInit(callType, data) {
		pluginUrls = _core.getComponentUrls('livestock');
		pluginVars = _core.getComponentVars('livestock');

		// pick the right function for the current call type
		if (callType && callType == 'products.data') {
			onCoreInitData(data);
		} else if (callType && callType == 'products.ui')  {
			onCoreInitUI(data);
		}
	}

	/**
	 * Initialize the data of the favourite list
	 * @param  {Object} data The data passed to the onCoreInit function
	 */
	function onCoreInitData(data) {
		// only set this state if the ajax functionality is active. after the ajax request there will
		// the state will be resetted
		if (pluginUrls.get_live_stock) {
			_core.setState('stockUpdatePending', true);
		}

		_core.getProductStockQuantity = function(){

			if (!pluginUrls.get_live_stock) {
				// if the livestock plugin is used but no ajax url is passed
				// we directly call the update complete function
				_stockUpdateCompleted();
				return false;
			}

			var productNumber = _core.products.parent.product.product_number;

			if(_core.products.parent.product.product_number_public && pluginVars.use_product_number_public){
				productNumber = _core.products.parent.product.product_number_public;
			}

			_core.ajax({
				url: pluginUrls.get_live_stock,
				type: 'GET',
				data: {
					shop_id: _core.products.parent.product.shop_id,
					product_number: productNumber,
					has_children: _core.products.children ? true : false
				},
				success: function(response){
					// gameday response
					if(typeof response.error != 'undefined' && typeof response.items != 'undefined'){
						response.data = response;
					}

					if (typeof response.data != 'undefined' && response.data !== null ) {
						var error = response.data.error || !response.data.items;
						if(!error){
							if(typeof _core.products.children != 'undefined' && Object.keys(_core.products.children).length > 0){

								// write children
								$.each(_core.products.children, function(id, child){

									if(typeof response.data.items[child.product.product_number] != 'undefined'){
										setNewAttributes(_core.products.children[id].product, response.data.items[child.product.product_number]);
									}
								});

							} else if (typeof response.data.items[_core.products.parent.product.product_number] != 'undefined'){
								// write parent
								setNewAttributes(_core.products.parent.product, response.data.items[_core.products.parent.product.product_number]);
							}

						}else{
							liveStockError();
						}
					}else{
						liveStockError();
					}
				},
				error : function(){liveStockError()},
				complete: function(){
					_stockUpdateCompleted();
				}
			});

			function _stockUpdateCompleted() {
				_core.setState('stockUpdatePending', false);
				_core.updateProductStockQuantity();
			}
		};

		/**
		 * Set new attributes to product based on new stock quantity
		 *
		 * @param product
		 * @param stockFormResponse
		 */
		function setNewAttributes(product, newStockQuantity) {
			/**
			 * If the stock quantity is positive or NULL the product can be ordered.
			 * If the quantity is 0, product can not be ordered.
			 */
			if (newStockQuantity === null) {
				product.ignore_stock = true;
				product.is_not_orderable = 0;
			} else {
				product.ignore_stock = false;
				product.stock_quantity = newStockQuantity;

				if (parseInt(product.stock_quantity) === 0) {
					product.stock_text =  $.i18n._('product_out_of_stock');
					product.is_not_orderable = 1;
				} else {
					product.stock_text = liveStockText(data.coreOptions.plugins.ShopgateLiveStock.itemStockDisplay, newStockQuantity);
					product.is_not_orderable = 0;
				}
			}

			// Set new available_text based on new stock_quantity
			if (!product.ignore_stock && parseInt(product.stock_quantity) == 0) {
				// If product is no longer available use default product_not_available test
				product.available_text = $.i18n._('product_not_available').trim();
			} else if (!product.available_text) {
				// If product doesn't have a available_text use default
				product.available_text = $.i18n._('product_available').trim();
			}
		}

        function liveStockError(){
			ajaxError = true;
            productContainerLiveStock.closest('.row').addClass('hidden');
            productContainerAvailableText.closest('.row').addClass('hidden');
			$('.js-available-text-row-container, .js-stock-quantity-row-container').addClass('hidden');

            _core.setState('stockUpdatePending', false);
            $.shopgate.modal({
                title: '',
                body: $.i18n._('product_live_stock_error')
            });
        }
    }

	/**
	 * Initialize the UI of the favourite list
	 * @param  {Object} data The data passed to the onCoreInit function
	 */
	function onCoreInitUI(data) {
		_initUI();
	}

	function _initUI() {
		scope = $('#content > .product');
		productContainerLiveStock = $('.container-live-stock', scope);
		productContainerStockQuantity = $('.container-stock-quantity', scope).addClass('hidden');
		liveStockPreloader = $('.live-stock-preloader', scope).removeClass('hidden');
		productContainerAvailableText = $('.container-available-text', scope).addClass('hidden');
	}

	function _onUpdateProduct(callType, productData) {
		if (callType && callType != 'products.ui') {return false;}

		var states = _core.getStates();

		// make tha ajax call and/or update the stock stuff
		if(!states.stockUpdatePending){
			_core.updateProductStockQuantity();
		} else {
			/**
			 * For debugging it's sometimes good to delay livestock update request.
			 */
			if (debugLazyLiveStock === true) {
				setTimeout(_core.getProductStockQuantity, 5000);
			} else {
				_core.getProductStockQuantity();
			}
		}
	}

	function _onUpdateProductStockQuantity(callType, data) {
		if (callType && callType != 'products.ui') {return;}
		var states = _core.getStates();

        if (data.product && !states.stockUpdatePending) {

			if (data.product.display_type == _core.DISPLAY_TYPE_LIST) {
				// remove quantity field for grouped product children if they are not orderable
				for (var id in _core.products.children) {
					var child = _core.products.children[id],
						$quantityContainer = $('.container-product-quantity[data-product-id=' + child.product.id + ']').removeClass('hidden');

					if (child.product.ignore_stock == false && parseInt(child.product.stock_quantity) == 0) {
						$quantityContainer.html(child.product.available_text).css({color: 'red'});
					}
				}
			} else {
				// First hide the row in any case
				var $liveStockContainer = productContainerLiveStock.closest('.row').addClass('hidden');

				if (typeof data.product.stock_quantity != 'undefined' && data.product.stock_text != "") {
					// Update the content of the line that shows the stock text
					productContainerStockQuantity.addClass('hidden').html(data.product.stock_text).removeClass('hidden');
					// Make the line visible again
					$liveStockContainer.removeClass('hidden');
				}

				$liveStockContainer.toggle(!Boolean(data.product.ignore_stock));

				productContainerAvailableText.addClass('hidden').html(data.product.available_text);
				if (parseInt(data.product.stock_quantity) == 0) {
					productContainerAvailableText.removeClass('text-success').addClass('text-danger').removeClass('hidden');
				} else {
					productContainerAvailableText.removeClass('text-danger').addClass('text-success').removeClass('hidden');
				}
			}
        }

	}

	function liveStockText(displayType, stockQuantity){
		var stockText = "";

		if (displayType == ITEM_STOCK_DISPLAY_DEFAULT) {
			if(stockQuantity <= 5){
				stockText = $.i18n._('live_stock_quantity_text', stockQuantity);
			}
		} else if (displayType == ITEM_STOCK_DISPLAY_ALWAYS_APPROX) {
			if(stockQuantity <= 5){
				stockText = $.i18n._('live_stock_quantity_text', stockQuantity);
			} else {
				stockText = $.i18n._('live_stock_quantity_approx', 5);
			}
		} else if (displayType == ITEM_STOCK_DISPLAY_ALWAYS_EXACT) {
			if (stockQuantity <= 5){
				stockText = $.i18n._('live_stock_quantity_text', stockQuantity);
			} else {
				stockText = $.i18n._('live_stock_quantity_exact', stockQuantity);
			}
		}

		return stockText;
	}

	function _onUpdateStates(callType, data) {
		if (callType && callType != 'products.ui') {return;}

		if (typeof data.stockUpdatePending !== 'undefined') {
			if (scope === null) {
				_initUI();
			}

			if (_core.getSelectedProduct().product.display_type == _core.DISPLAY_TYPE_LIST) {
				liveStockPreloader.toggleClass('hidden', !data.stockUpdatePending);
				$('.child-list').find('.grouped-quantity, .js-item-amount').toggleClass('hidden', data.stockUpdatePending);
			} else {
				liveStockPreloader.toggleClass('hidden', !data.stockUpdatePending);
				$('.container-stock-quantity, .container-available-text').toggleClass('hidden', data.stockUpdatePending);
			}
		}
	}

	var hooks = {
		vendor: 'Shopgate',
		name: 'ShopgateLiveStock',
		type: ['products.ui', 'products.data'],
		onCoreInit: 					_onCoreInit,
		onUpdateProduct: 				_onUpdateProduct,
		onUpdateProductStockQuantity:   _onUpdateProductStockQuantity,
		onUpdateStates: _onUpdateStates
	};

	return hooks;
};

if (typeof ShopgateProductDetailsCore == 'object' && typeof ShopgateProductDetailsCore.registerPlugin == 'function') {
	if (ShopgateProductDetailsCore.isComponentActive('livestock')) {
		ShopgateProductDetailsCore.registerPlugin(liveStockPlugin);
	}
} else {
	console.warn('No instance of "ShopgateProductDetailsCore" found');
}


// WEBPACK FOOTER //
// ./Library/1.0/common/product_details/jquery.shopgate-product-details-live-stock.js